export default __webpack_public_path__ + "static/media/tech5.4bff7b07.svg";